// Author : Vishnu
//Version :0.0.1
// MODIFIED DATE: 18/08/2025
import { docodeHexResponse } from '../../_common/common.utils';
import ChangeMeetingDateActionTypes from './change-meeting-date.type';

const INITIAL_STATE = {
	updateBranchMeetingDateResponse: null,

	updateSingleBranchMeetingDateResponse: null,

	updateSingleCenterMeetingDateResponse: null,
	updateSingleCenterMeetingDateArr: [],

	getBranchMeetingDateDetailsResponse: null,
	getBranchMeetingDateDetailsArr: [],

	getLoanCenterGroupDetailsResponse: null,
	getLoanCenterGroupDetailsArr: [],

	getParticularLoanCenterGroupDetailsResponse: null,
	getParticularLoanCenterGroupDetailsArr: [],

	updateBranchMeetingDateAutoLoanResponse: null,

	updateSingleBranchMeetingDateAutoLoanResponse: null,

	updateSingleCenterMeetingDateAutoLoanResponse: null,
	updateSingleCenterMeetingDateAutoLoanArr: [],

	getBranchMeetingDateDetailsAutoLoanResponse: null,
	getBranchMeetingDateDetailsAutoLoanArr: [],

	getLoanCenterGroupDetailsAutoLoanResponse: null,
	getLoanCenterGroupDetailsAutoLoanArr: [],

	getParticularLoanCenterGroupDetailsAutoLoanResponse: null,
	getParticularLoanCenterGroupDetailsAutoLoanArr: [],
};

const changeMeetingDateReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/***************   Start Update Branch Meeting Date ******************/
		case ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_SUCCESS:
			return {
				...state,
				updateBranchMeetingDateResponse: action.payload,
			};

		case ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_FAILURE:
			return { ...state, updateBranchMeetingDateResponse: action.payload };

		case ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_RESPONSE_CHANGED:
			return { ...state, updateBranchMeetingDateResponse: null };
		/***************   End Update Branch Meeting Date ******************/

		/***************   Start Update Branch Meeting Date Auto Loan ******************/
		case ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_SUCCESS:
			return {
				...state,
				updateBranchMeetingDateAutoLoanResponse: action.payload,
			};

		case ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_FAILURE:
			return {
				...state,
				updateBranchMeetingDateAutoLoanResponse: action.payload,
			};

		case ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_RESPONSE_CHANGED:
			return { ...state, updateBranchMeetingDateAutoLoanResponse: null };
		/***************   End Update Branch Meeting Date Auto Loan ******************/

		/***************   Get Branch Meeting Date Details Start ******************/
		case ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_SUCCESS:
			return {
				...state,
				getBranchMeetingDateDetailsResponse: action.payload,
				getBranchMeetingDateDetailsArr: docodeHexResponse(
					action.payload,
					'FetchBranchMeetingDateDetailsKey',
				),
			};

		case ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_FAILURE:
			return { ...state, getBranchMeetingDateDetailsResponse: action.payload };

		case ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_RESPONSE_CHANGED:
			return { ...state, getBranchMeetingDateDetailsResponse: null };
		/***************   Get Branch Meeting Date Details End ******************/

		/***************   Get Branch Meeting Date Details Auto Loan Start ******************/
		case ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_SUCCESS:
			return {
				...state,
				getBranchMeetingDateDetailsAutoLoanResponse: action.payload,
				getBranchMeetingDateDetailsAutoLoanArr: docodeHexResponse(
					action.payload,
					'FetchBranchMeetingDateDetailsAutoLoanKey',
				),
			};

		case ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_FAILURE:
			return {
				...state,
				getBranchMeetingDateDetailsAutoLoanResponse: action.payload,
			};

		case ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_RESPONSE_CHANGED:
			return { ...state, getBranchMeetingDateDetailsAutoLoanResponse: null };
		/***************   Get Branch Meeting Date Details Auto Loan End ******************/

		/***************  Get Loan Center Group Details Start ******************/
		case ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_SUCCESS:
			return {
				...state,
				getLoanCenterGroupDetailsResponse: action.payload,
				getLoanCenterGroupDetailsArr: docodeHexResponse(
					action.payload,
					'LoanCenterGroupDetailsListKey',
				),
			};

		case ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_FAILURE:
			return { ...state, getLoanCenterGroupDetailsResponse: action.payload };

		case ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_RESPONSE_CHANGED:
			return { ...state, getLoanCenterGroupDetailsResponse: null };
		/***************  Get Loan Center Group Details End ******************/

		/***************  Get Loan Center Group Details Auto Loan Start ******************/
		case ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_SUCCESS:
			return {
				...state,
				getLoanCenterGroupDetailsAutoLoanResponse: action.payload,
				getLoanCenterGroupDetailsAutoLoanArr: docodeHexResponse(
					action.payload,
					'LoanCenterGroupDetailsListAutoLoanKey',
				),
			};

		case ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_FAILURE:
			return {
				...state,
				getLoanCenterGroupDetailsAutoLoanResponse: action.payload,
			};

		case ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_RESPONSE_CHANGED:
			return { ...state, getLoanCenterGroupDetailsAutoLoanResponse: null };
		/***************  Get Loan Center Group Details Auto Loan End ******************/

		/***************  Get Loan Index Details Based On Center Group Start ******************/
		case ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_SUCCESS:
			return {
				...state,
				getParticularLoanCenterGroupDetailsResponse: action.payload,
				getParticularLoanCenterGroupDetailsArr: docodeHexResponse(
					action.payload,
					'FetchLoanDetailsBasedOnCenterGroupKey',
				),
			};

		case ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_FAILURE:
			return { ...state, getParticularLoanCenterGroupDetailsResponse: action.payload };

		case ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_RESPONSE_CHANGED:
			return { ...state, getParticularLoanCenterGroupDetailsResponse: null };
		/***************  Get Loan Index Details Based On Center Group End ******************/

		/***************  Get Loan Index Details Based On Center Group Auto Loan Start ******************/
		case ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_SUCCESS:
			return {
				...state,
				getParticularLoanCenterGroupDetailsAutoLoanResponse: action.payload,
				getParticularLoanCenterGroupDetailsAutoLoanArr: docodeHexResponse(
					action.payload,
					'FetchLoanDetailsBasedOnCenterGroupAutoLoanKey',
				),
			};

		case ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_FAILURE:
			return {
				...state,
				getParticularLoanCenterGroupDetailsAutoLoanResponse: action.payload,
			};

		case ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_RESPONSE_CHANGED:
			return {
				...state,
				getParticularLoanCenterGroupDetailsAutoLoanResponse: null,
			};
		/***************  Get Loan Index Details Based On Center Group Auto Loan End ******************/

		/***************  Start Update Branch New Meeting Date ******************/
		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_SUCCESS:
			return {
				...state,
				updateSingleBranchMeetingDateResponse: action.payload,
			};
		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_FAILURE:
			return { ...state, updateSingleBranchMeetingDateResponse: action.payload };

		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_RESPONSE_CHANGED:
			return { ...state, updateSingleBranchMeetingDateResponse: null };
		/***************  End Update Branch New Meeting Date ******************/

		/***************  Start Update Branch New Meeting Date Auto Loan ******************/
		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_SUCCESS:
			return {
				...state,
				updateSingleBranchMeetingDateAutoLoanResponse: action.payload,
			};
		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_FAILURE:
			return {
				...state,
				updateSingleBranchMeetingDateAutoLoanResponse: action.payload,
			};

		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_RESPONSE_CHANGED:
			return {
				...state,
				updateSingleBranchMeetingDateAutoLoanResponse: null,
			};
		/***************  End Update Branch New Meeting Date Auto Loan ******************/

		/***************  Update Loan Index Meeting Date Time Start ******************/
		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_SUCCESS:
			return {
				...state,
				updateSingleCenterMeetingDateResponse: action.payload,
				updateSingleCenterMeetingDateArr: docodeHexResponse(
					action.payload,
					'UpdateMeetingDateAndTimeForLoanIndexKey',
				),
			};

		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_FAILURE:
			return { ...state, updateSingleCenterMeetingDateResponse: action.payload };

		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_RESPONSE_CHANGED:
			return { ...state, updateSingleCenterMeetingDateResponse: null };
		/***************  Update Loan Index Meeting Date Time End ******************/

		/***************  Update Loan Index Meeting Date Time Auto Loan Start ******************/
		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_SUCCESS:
			return {
				...state,
				updateSingleCenterMeetingDateAutoLoanResponse: action.payload,
				updateSingleCenterMeetingDateAutoLoanArr: docodeHexResponse(
					action.payload,
					'UpdateMeetingDateAndTimeForLoanIndexAutoLoanKey',
				),
			};

		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_FAILURE:
			return {
				...state,
				updateSingleCenterMeetingDateAutoLoanResponse: action.payload,
			};

		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_RESPONSE_CHANGED:
			return { ...state, updateSingleCenterMeetingDateAutoLoanResponse: null };
		/***************  Update Loan Index Meeting Date Time Auto Loan End ******************/

		/***************  Update Loan Index Meeting Date Time Member Wise Start ******************/
		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_SUCCESS:
			return {
				...state,
				updateSingleMemberMeetingDateResponse: action.payload,
			};

		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_FAILURE:
			return { ...state, updateSingleMemberMeetingDateResponse: action.payload };

		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_RESPONSE_CHANGED:
			return { ...state, updateSingleMemberMeetingDateResponse: null };
		/***************  Update Loan Index Meeting Date Time Member Wise End ******************/

		/***************  Update Loan Index Meeting Date Time Member Wise Auto Loan Start ******************/
		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_SUCCESS:
			return {
				...state,
				updateSingleMemberMeetingDateAutoLoanResponse: action.payload,
			};

		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_FAILURE:
			return {
				...state,
				updateSingleMemberMeetingDateAutoLoanResponse: action.payload,
			};

		case ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_RESPONSE_CHANGED:
			return { ...state, updateSingleMemberMeetingDateAutoLoanResponse: null };
		/***************  Update Loan Index Meeting Date Time Member Wise Auto Loan End ******************/

		default:
			return state;
	}
};

export default changeMeetingDateReducer;
